import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
// import IntroAnimation from "../components/golf/IntroAnimation";
import SearchView from "../components/golf/SearchView";
import CourseDetail from "../components/golf/CourseDetail";
import CheckoutView from "../components/golf/CheckoutView";
import ConfirmationView from "../components/golf/ConfirmationView";
import UnifiedConfirmationView from "../components/bookings/UnifiedConfirmationView";
import { FERRIESCourses } from "@/data/dummyGolfCourses";
import { getAllCourses } from "@/services/courseService";
import FerrySearchView from "../components/ferry/FerrySearchView";
import FerryDetail from "../components/ferry/FerryDetail";
import FerryCheckoutView from "../components/ferry/FerryCheckoutView";
import FerryConfirmationView from "../components/ferry/FerryConfirmationView";
import { TRANSPORT_VEHICLES } from "@/data/dummyTransport";
import { ACCOMMODATIONS } from "@/data/dummyAccommodation";
import TransportSearchView from "../components/transport/TransportSearchView";
import TransportDetail from "../components/transport/TransportDetail";
import TransportCheckoutView from "../components/transport/TransportCheckoutView";
import TransportConfirmationView from "../components/transport/TransportConfirmationView";
import AccommodationSearchView from "../components/accommodation/AccommodationSearchView";
import AccommodationDetail from "../components/accommodation/AccommodationDetail";
import AccommodationCheckoutView from "../components/accommodation/AccommodationCheckoutView";
import AccommodationConfirmationView from "../components/accommodation/AccommodationConfirmationView";

export default function GolfBooking() {
  // const [showIntro, setShowIntro] = useState(true);
  const [bookingMode, setBookingMode] = useState("golf");
  const [selectedFerry, setSelectedFerry] = useState(null);
  const [view, setView] = useState(
    /** @type {"search" | "detail" | "checkout" | "confirmation" | "unified_confirmation"} */ (
      "search"
    ),
  );
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [bookingData, setBookingData] = useState({
    date: new Date(),
    players: 2,
    teeTime: "",
    paymentMethod: "",
  });


  //Feery Bookings
  // Filter ferries to only show routes relevant to the selected golf course.
  // Courses with ferry_route_ids: null show all ferries.
  const ferries = selectedCourse?.ferry_route_ids
    ? FERRIESCourses.filter(f => selectedCourse.ferry_route_ids.includes(f.id))
    : FERRIESCourses;
  const [ferryBookingData, setFerryBookingData] = useState(
    /** @type {{ date: Date; returnDate: Date | null; passengers: number; isRoundTrip: boolean; departureTime: string; returnDepartureTime: string; vehicleType: string }} */ ({
      date: new Date(),
      returnDate: null,
      passengers: 1,
      isRoundTrip: false,
      departureTime: "",
      returnDepartureTime: "",
      vehicleType: "",
    }),
  );

  const [selectedTransport, setSelectedTransport] = useState(null);
  const [transportBookingData, setTransportBookingData] = useState(
    /** @type {{ date: Date; returnDate: Date | null; passengers: number; pickupTime: string; returnPickupTime: string; isRoundTrip: boolean }} */ ({
      date: new Date(),
      returnDate: null,
      passengers: 2,
      pickupTime: "",
      returnPickupTime: "",
      isRoundTrip: false,
    })
  );

  const [selectedHotel, setSelectedHotel] = useState(null);
  const [accommodationBookingData, setAccommodationBookingData] = useState(
    /** @type {{ checkin: Date | null; checkout: Date | null; guests: number; nights: number; totalAmount: number }} */ ({
      checkin: null,
      checkout: null,
      guests: 2,
      nights: 1,
      totalAmount: 0,
    })
  );

  const [confirmation, setConfirmation] = useState(null);

  // Sequential booking flow state
  const [completedBookings, setCompletedBookings] = useState(
    /** @type {{
     * golf: { date: string | Date; players: number } | null;
     * ferry: any;
     * transport: any;
     * accommodation: any;
     */
    ({
      golf: null,
      ferry: null,
      transport: null,
      accommodation: null,
    }),
  );

  //Feery Booking
  /**
   * @param {Date} date
   * @param {Date|null} returnDate
   * @param {number} passengers
   * @param {string} departureTime
   * @param {string} returnDepartureTime
   * @param {string} vehicleType
   * @param {boolean} isRoundTrip
   */
  const handleProceedToFerryCheckout = (
    date,
    returnDate,
    passengers,
    departureTime,
    returnDepartureTime,
    vehicleType,
    isRoundTrip,
  ) => {
    setFerryBookingData({
      date,
      returnDate,
      passengers,
      departureTime,
      returnDepartureTime,
      vehicleType,
      isRoundTrip,
    });
    setView("checkout");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleProceedToFerry = () => {
    setBookingMode("ferry");
    setView("search");
    setSelectedFerry(null);
    setConfirmation(null);
    const golfBooking = completedBookings.golf;
    if (golfBooking) {
      setFerryBookingData((prev) => ({
        ...prev,
        date: new Date(golfBooking.date),
        passengers: golfBooking.players,
      }));
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /**
   * @param {any} ferry
   * @param {any} date
   * @param {any} returnDate
   * @param {number} passengers
   * @param {boolean} isRoundTrip
   */
  const handleSelectFerry = (
    ferry,
    date,
    returnDate,
    passengers,
    isRoundTrip,
  ) => {
    setSelectedFerry(ferry);
    setFerryBookingData({
      ...ferryBookingData,
      date,
      returnDate,
      passengers,
      isRoundTrip,
    });
    setView("detail");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  
/** @param {any} ferrySelectionData */
  const handleConfirmFerryPayment = async (ferrySelectionData) => {
    setCompletedBookings(prev => ({ ...prev, ferry: ferrySelectionData }));
    setConfirmation(ferrySelectionData);
    setView("confirmation");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleProceedToTransport = () => {
    setBookingMode("transportation");
    setView("search");
    setSelectedTransport(null);
    setConfirmation(null);
    const ferryBooking = completedBookings.ferry;
    const golfBooking = completedBookings.golf;
    if (ferryBooking || golfBooking) {
      setTransportBookingData(prev => ({
        ...prev,
        date: ferryBooking ? new Date(ferryBooking.date) : golfBooking ? new Date(golfBooking.date) : prev.date,
        passengers: ferryBooking?.passengers || golfBooking?.players || prev.passengers,
      }));
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /**
   * @param {Date} date
   * @param {Date|null} returnDate
   * @param {number} passengers
   * @param {string} pickupTime
   * @param {string} returnPickupTime
   * @param {boolean} isRoundTrip
   */
  const handleProceedToTransportCheckout = (date, returnDate, passengers, pickupTime, returnPickupTime, isRoundTrip) => {
    setTransportBookingData({ date, returnDate, passengers, pickupTime, returnPickupTime, isRoundTrip });
    setView("checkout");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /** @param {any} transportSelectionData */
  const handleConfirmTransport = async (transportSelectionData) => {
    setCompletedBookings(prev => ({ ...prev, transport: transportSelectionData }));
    setConfirmation(transportSelectionData);
    setView("confirmation");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleProceedToAccommodation = () => {
    setBookingMode("accommodation");
    setView("search");
    setSelectedHotel(null);
    setConfirmation(null);
    const ferryBooking = completedBookings.ferry;
    const golfBooking = completedBookings.golf;
    const checkinDate = ferryBooking ? new Date(ferryBooking.date)
      : golfBooking ? new Date(golfBooking.date)
      : null;
    if (checkinDate) {
      setAccommodationBookingData(prev => ({
        ...prev,
        checkin: checkinDate,
        guests: golfBooking?.players || prev.guests,
      }));
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /**
   * @param {Date} checkin
   * @param {Date} checkout
   * @param {number} guests
   * @param {number} nights
   * @param {number} totalAmount
   */
  const handleProceedToAccommodationCheckout = (checkin, checkout, guests, nights, totalAmount) => {
    setAccommodationBookingData({ checkin, checkout, guests, nights, totalAmount });
    setView("checkout");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /** @param {any} accommodationData */
  const handleConfirmAccommodation = async (accommodationData) => {
    setCompletedBookings(prev => ({ ...prev, accommodation: accommodationData }));
    setConfirmation(accommodationData);
    setView("confirmation");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };



  // Fetch golf courses from Firestore (same "course" collection the admin
  // create-course page writes to) instead of the old dummy fixture.
  const [golfCourses, setGolfCourses] = useState([]);
  const [isLoadingCourses, setIsLoadingCourses] = useState(true);

  useEffect(() => {
    (async () => {
      setIsLoadingCourses(true);
      try {
        const result = await getAllCourses();
        setGolfCourses(Array.isArray(result) ? result : []);
      } catch (err) {
        console.error("Failed to load golf courses:", err);
      } finally {
        setIsLoadingCourses(false);
      }
    })();
  }, []);

  /** @param {any} course */
  const handleSelectCourse = (course) => {
    setSelectedCourse(course);
    setView("detail");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /** @param {any} date, @param {number} players, @param {string | null} teeTime */
  const handleProceedToCheckout = (date, players, teeTime) => {
    setBookingData({
      date: date ? new Date(date) : new Date(),
      players,
      teeTime: teeTime ?? "",
      paymentMethod: "",
    });
    setView("checkout");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /** @param {any} golfSelectionData */
  const handleConfirmPayment = async (golfSelectionData) => {
    setCompletedBookings((prev) => ({ ...prev, golf: golfSelectionData }));
    setConfirmation(golfSelectionData);
    setView("confirmation");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleBackToSearch = () => {
    setBookingMode("golf");
    setView("search");
    setSelectedFerry(null);
    setSelectedCourse(null);
    setBookingData({
      date: new Date(),
      players: 2,
      teeTime: "",
      paymentMethod: "",
    });
    setConfirmation(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleViewUnifiedConfirmation = () => {
    setView("unified_confirmation");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleReturnToMenu = () => {
    setBookingMode("golf");
    setView("search");
    setSelectedCourse(null);
    setConfirmation(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // if (showIntro) {
  //   return <IntroAnimation />;
  // }

  return (
    <div className="min-h-screen bg-white">

      <AnimatePresence mode="wait">
        {/* Golf Booking Flow */}
        {bookingMode === "golf" && view === "search" && (
          <motion.div
            key="golf-search"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <SearchView
              courses={golfCourses.map((c) => ({
                id: c.id,
                name: c.name,
                city: c.city || "",
                country: c.country || "",
                image: c.image || "",
                description: c.description || "",
                price: c.price ?? 0,
                rating: c.rating,
                difficulty: c.difficulty || "",
                amenities: c.amenities || [],
                available_times: c.available_times || [],
                fees_included: c.fees_included || [],
                images: c.images || [],
              }))}
              onSelectCourse={handleSelectCourse}
              isLoading={isLoadingCourses}
              title="About Our Courses"
            />
          </motion.div>
        )}

        {bookingMode === "golf" && view === "detail" && selectedCourse && (
          <motion.div
            key="golf-detail"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            <CourseDetail
              course={selectedCourse}
              onBack={() => setView("search")}
            />
          </motion.div>
        )}

        {bookingMode === "golf" && view === "checkout" && selectedCourse && (
          <motion.div
            key="golf-checkout"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            <CheckoutView
              course={selectedCourse}
              bookingData={bookingData}
              onBack={() => setView("detail")}
              onConfirm={handleConfirmPayment}
              onReturnToMenu={handleReturnToMenu}
            />
          </motion.div>
        )}

        {bookingMode === "golf" && view === "confirmation" && confirmation && (
          <motion.div
            key="golf-confirmation"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.4 }}
          >
            <ConfirmationView
              confirmation={confirmation}
              onBackToSearch={handleBackToSearch}
              onProceedToFerry={handleProceedToFerry}
              onCompleteBooking={handleViewUnifiedConfirmation}
              showNextStep={true}
            />
          </motion.div>
        )}

        {view === "unified_confirmation" && (
          <motion.div
            key="unified-confirmation"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.4 }}
          >
            <UnifiedConfirmationView
              bookings={completedBookings}
              onBackToSearch={handleBackToSearch}
              totalAmount={0}
              ferry={null}
              transport={null}
            />
          </motion.div>
        )}

        {bookingMode === "ferry" && view === "search" && (
          <motion.div
            key="ferry-search"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <FerrySearchView
              ferries={ferries}
              onSelectFerry={handleSelectFerry}
              isLoading={false}
              prefillDate={
                completedBookings.golf
                  ? new Date(completedBookings.golf.date)
                  : null
              }
              prefillPassengers={completedBookings.golf?.players || 1}
            />
          </motion.div>
        )}

        {bookingMode === "ferry" && view === "detail" && selectedFerry && (
          <motion.div
            key="ferry-detail"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            <FerryDetail
              ferry={selectedFerry}
              initialDate={ferryBookingData.date}
              initialReturnDate={ferryBookingData.returnDate}
              initialPassengers={ferryBookingData.passengers}
              isRoundTrip={ferryBookingData.isRoundTrip}
              onBack={() => setView("search")}
              onProceedToCheckout={handleProceedToFerryCheckout}
            />
          </motion.div>
        )}

        {bookingMode === "ferry" && view === "checkout" && selectedFerry && (
          <motion.div
            key="ferry-checkout"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            <FerryCheckoutView
              ferry={selectedFerry}
              bookingData={ferryBookingData}
              onBack={() => setView("detail")}
              onConfirm={handleConfirmFerryPayment}
              onReturnToMenu={handleReturnToMenu}
            />
          </motion.div>
        )}

        {bookingMode === "ferry" && view === "confirmation" && confirmation && (
          <motion.div
            key="ferry-confirmation"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.4 }}
          >
            <FerryConfirmationView
              confirmation={confirmation}
              onBackToSearch={handleBackToSearch}
              onProceedToTransport={handleProceedToTransport}
              onCompleteBooking={handleViewUnifiedConfirmation}
              showNextStep={true}
            />
          </motion.div>
        )}
        {/* Transportation Flow */}
        {bookingMode === "transportation" && view === "search" && (
          <motion.div key="transport-search" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
            <TransportSearchView
              vehicles={TRANSPORT_VEHICLES}
              onSelectVehicle={(vehicle) => { setSelectedTransport(vehicle); setView("detail"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              prefillDate={
                completedBookings.ferry ? new Date(completedBookings.ferry.date)
                : completedBookings.golf ? new Date(completedBookings.golf.date)
                : null
              }
              prefillPassengers={completedBookings.ferry?.passengers || completedBookings.golf?.players || 2}
            />
          </motion.div>
        )}

        {bookingMode === "transportation" && view === "detail" && selectedTransport && (
          <motion.div key="transport-detail" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} transition={{ duration: 0.3 }}>
            <TransportDetail
              vehicle={selectedTransport}
              initialDate={transportBookingData.date}
              initialPassengers={transportBookingData.passengers}
              onBack={() => setView("search")}
              onProceedToCheckout={handleProceedToTransportCheckout}
            />
          </motion.div>
        )}

        {bookingMode === "transportation" && view === "checkout" && selectedTransport && (
          <motion.div key="transport-checkout" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} transition={{ duration: 0.3 }}>
            <TransportCheckoutView
              vehicle={selectedTransport}
              bookingData={transportBookingData}
              onBack={() => setView("detail")}
              onConfirm={handleConfirmTransport}
              onReturnToMenu={handleReturnToMenu}
            />
          </motion.div>
        )}

        {bookingMode === "transportation" && view === "confirmation" && confirmation && (
          <motion.div key="transport-confirmation" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} transition={{ duration: 0.4 }}>
            <TransportConfirmationView
              confirmation={confirmation}
              onBackToSearch={handleBackToSearch}
              onProceedToAccommodation={handleProceedToAccommodation}
              onCompleteBooking={handleViewUnifiedConfirmation}
              showNextStep={true}
            />
          </motion.div>
        )}

        {/* Accommodation Flow */}
        {bookingMode === "accommodation" && view === "search" && (
          <motion.div key="accommodation-search" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
            <AccommodationSearchView
              hotels={ACCOMMODATIONS}
              onSelectHotel={(hotel) => { setSelectedHotel(hotel); setView("detail"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              prefillCheckin={
                completedBookings.ferry ? new Date(completedBookings.ferry.date)
                : completedBookings.golf ? new Date(completedBookings.golf.date)
                : null
              }
              prefillGuests={completedBookings.golf?.players || 2}
            />
          </motion.div>
        )}

        {bookingMode === "accommodation" && view === "detail" && selectedHotel && (
          <motion.div key="accommodation-detail" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} transition={{ duration: 0.3 }}>
            <AccommodationDetail
              hotel={selectedHotel}
              initialCheckin={accommodationBookingData.checkin}
              initialCheckout={accommodationBookingData.checkout}
              initialGuests={accommodationBookingData.guests}
              onBack={() => setView("search")}
              onProceedToCheckout={handleProceedToAccommodationCheckout}
            />
          </motion.div>
        )}

        {bookingMode === "accommodation" && view === "checkout" && selectedHotel && (
          <motion.div key="accommodation-checkout" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} transition={{ duration: 0.3 }}>
            <AccommodationCheckoutView
              hotel={selectedHotel}
              bookingData={accommodationBookingData}
              onBack={() => setView("detail")}
              onConfirm={handleConfirmAccommodation}
              onReturnToMenu={handleReturnToMenu}
            />
          </motion.div>
        )}

        {bookingMode === "accommodation" && view === "confirmation" && confirmation && (
          <motion.div key="accommodation-confirmation" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} transition={{ duration: 0.4 }}>
            <AccommodationConfirmationView
              confirmation={confirmation}
              onBackToSearch={handleBackToSearch}
              onCompleteBooking={handleViewUnifiedConfirmation}
              showNextStep={true}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
